import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/agreement/:protocolId/:contentType', component: () => import('@/views/agreement/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  },
  {
    path: '/base',
    component: Layout,
    redirect: '/base/user/',
    name: 'base',
    meta: {title: '平台用户', icon: 'product-list'},
    children: [{
      path: 'user',
      name: 'user',
      component: () => import('@/views/sys/user/index'),
      meta: {title: '用户管理', icon: 'product-list'}
    },
    ]
  },

  {
     path: '/recharge',
     component: Layout,
     redirect: '/recharge/list/',
     name: 'recharge',
     meta: {title: '订单管理', icon: 'product-list'},
     children: [
        {
          path: 'order',
          name: 'order',
          component: () => import('@/views/taskorder/order'),
          meta: {title: '充值订单', icon: 'product-list'}
        },
        {
          path: 'rechargeIndex',
          name: 'rechargeIndex', component: () => import('@/views/system/rechargeIndex'),
          meta: {title: '充值规格设置', icon: 'product-list'}
        },
     ]
  },
 {
   path: '/plat',
   component: Layout,
   redirect: '/plat/list/',
   name: 'plat',
   meta: {title: '应用管理', icon: 'product-list'},
   children: [
      {
         path: 'apkIndex',
         name: 'apkIndex',
         component: () => import('@/views/system/apkIndex'),
         meta: {title: '应用设置', icon: 'product-list'}
      },
      {
         path: 'configIndex',
         name: 'configIndex',
         component: () => import('@/views/system/configIndex'),
         meta: {title: '支付方式设置', icon: 'product-list'}
      },
   ]
  },

 {
    path: '/admin',
    component: Layout,
    redirect: '/admin/list/',
    name: 'recharge',
    meta: {title: '管理员管理', icon: 'product-list'},
    children: [
    {
      path: 'adminUser',
      name: 'adminUser',
      component: () => import('@/views/system/index'),
      meta: {title: '管理员设置', icon: 'product-list'}
    }]
  },

  {
    path: '/ext',
    component: Layout,
    redirect: '/ext/list/',
    name: 'recharge',
    meta: {title: '推广介绍管理', icon: 'product-list'},
    children: [
    {
      path: 'extList',
      name: 'extList',
      component: () => import('@/views/ext/index'),
      meta: {title: '推广介绍设置', icon: 'product-list'}
    }]
  },

  {
    path: '/system',
    component: Layout,
    redirect: '/system/rewardTask',
    name: 'system',
    meta: {title: '系统设置', icon: 'product-list'},
    children: [
    // {
    //   path: 'downloadIndex',
    //   name: 'downloadIndex',
    //   component: () => import('@/views/system/downloadIndex'),
    //   meta: {title: '下载设置', icon: 'product-list'}
    // },
    // {
    //   path: 'versionIndex',
    //   name: 'versionIndex',
    //   component: () => import('@/views/system/versionIndex'),
    //   meta: {title: '版本管理', icon: 'sms-coupon'}
    // },
    // {
    //   path: 'teamIndex',
    //   name: 'teamIndex',
    //   component: () => import('@/views/system/teamIndex'),
    //   meta: {title: '团队设置',icon: 'sms-new'},
    // },


    // {
    //   path: 'goldSpecs',
    //   name: 'goldSpecs',
    //   component: () => import('@/views/system/goldSpecs'),
    //   meta: {title: '金币规格设置', icon: 'sms-subject'}
    // },
    // {
    //   path: 'msgIndex',
    //   name: 'msgIndex',
    //   component: () => import('@/views/system/msgIndex'),
    //   meta: {title: '公告设置',icon: 'example'},
    // },
    // {
    //   path: 'newIndex',
    //   name: 'newIndex',
    //   component: () => import('@/views/system/newIndex'),
    //   meta: {title: '消息设置',icon: 'example'},
    // },
    {
      path: 'smsIndex',
      name: 'smsIndex',
      component: () => import('@/views/system/smsIndex'),
      meta: {title: '短信查询', icon: 'product-list'},
    },
   {
      path: 'imgUrl',
      name: 'imgUrl',
      component: () => import('@/views/system/fileIndex'),
      meta: {title: '图片换地址', icon: 'product-list'},
    },
   {
      path: 'agreementIndex',
      name: 'agreementIndex',
      component: () => import('@/views/system/agreementIndex'),
      meta: {title: '协议设置', icon: 'order-setting'},
    },
   {
      path: 'richIndex',
      name: 'richIndex',
      component: () => import('@/views/system/richIndex'),
      meta: {title: '富文本链接', icon: 'order-setting'},
    },
   {
      path: 'switchIndex',
      name: 'switchIndex',
      component: () => import('@/views/system/switchIndex'),
      meta: {title: '开关设置', icon: 'order-setting'},
    },
   {
      path: 'opinionIndex',
      name: 'opinionIndex',
      component: () => import('@/views/system/opinionIndex'),
      meta: {title: '意见或建议', icon: 'product-list'}
   }]
  },
 {
    path: '/config',
    component: Layout,
    redirect: '/config/bannerIndex',
    name: 'config',
    meta: {title: '基础配置', icon: 'product-list'},
    children: [
    {
      path: 'bannerIndex',
      name: 'bannerIndex',
      component: () => import('@/views/config/bannerIndex'),
      meta: {title: 'banner广告', icon: 'product-list'},
    },
    {
      path: 'dictIndex',
      name: 'dictIndex',
      component: () => import('@/views/config/dictIndex'),
      meta: {title: '数据字典', icon: 'product-list'},
    },
   ]
 },

 {
    path: '/py',
    component: Layout,
    redirect: '/peiyin/typeList',
    name: 'py',
    meta: {title: '配音管理', icon: 'product-list'},
    children: [
      {
        path: 'typeList',
        name: 'typeList',
        component: () => import('@/views/peiyin/peiyinList'),
        meta: {title: '配音场景分类', icon: 'product-list'},
      } ,
      {
        path: 'zhuBoList',
        name: 'zhuBoList',
        component: () => import('@/views/peiyin/zhuBoList'),
        meta: {title: '配音场主播', icon: 'product-list'},
      },
     {
        path: 'zhuboMoraleStyledemoList',
        name: 'zhuboMoraleStyledemoList',
        component: () => import('@/views/peiyin/zhuboMoraleStyledemoList'),
        meta: {title: '主播情绪样例', icon: 'product-list'},
     },
     {
        path: 'peiyinHistoryList',
        name: 'peiyinHistoryList',
        component: () => import('@/views/peiyin/peiyinHistoryList'),
        meta: {title: '配音历史记录', icon: 'product-list'},
     },
     {
        path: 'bgmTypeList',
        name: 'bgmTypeList',
        component: () => import('@/views/peiyin/bgmTypeList'),
        meta: {title: '背景音乐分类', icon: 'product-list'},
     },
    {
        path: 'bgmList',
        name: 'bgmList',
        component: () => import('@/views/peiyin/bgmList'),
        meta: {title: '背景音乐列表', icon: 'product-list'},
     },
    {
        path: 'demoTypeList',
        name: 'demoTypeList',
        component: () => import('@/views/peiyin/demoTypeList'),
        meta: {title: '配音样例分类', icon: 'product-list'},
    },
    {
        path: 'demoList',
        name: 'demoList',
        component: () => import('@/views/peiyin/demoList'),
        meta: {title: '配音样例列表', icon: 'product-list'},
    }]
  },

  {
      path: '/func',
      component: Layout,
      redirect: '/func/noteBookBackupHistoryList',
      name: 'func',
      meta: {title: '功能管理', icon: 'product-list'},
      children: [
        {
          path: 'noteBookBackupHistoryList',
          name: 'noteBookBackupHistoryList',
          component: () => import('@/views/func/noteBookBackupHistoryList'),
          meta: {title: '日记备份', icon: 'product-list'},
         } ,
        {
            path: 'wenAnHistoryList',
            name: 'wenAnHistoryList',
            component: () => import('@/views/func/wenAnHistoryList'),
            meta: {title: '文案记录', icon: 'product-list'},
        },
        {
            path: 'quShuiYinHistoryList',
            name: 'quShuiYinHistoryList',
            component: () => import('@/views/func/quShuiYinHistoryList'),
            meta: {title: '去水印记录', icon: 'product-list'},
        },
        {
            path: 'zhengJianZhaoMakeHistoryList',
            name: 'zhengJianZhaoMakeHistoryList',
            component: () => import('@/views/func/zhengJianZhaoMakeHistoryList'),
            meta: {title: '证件照记录', icon: 'product-list'},
        },
        {
            path: 'zhengJianZhaoCountHistoryList',
            name: 'zhengJianZhaoCountHistoryList',
            component: () => import('@/views/func/zhengJianZhaoCountHistoryList'),
            meta: {title: '证件照扣减', icon: 'product-list'},
        },
        {
            path: 'wenanTypeList',
            name: 'wenanTypeList',
            component: () => import('@/views/func/wenanTypeList'),
            meta: {title: '文案分类列表', icon: 'product-list'},
        },
        {
            path: 'wenanList',
            name: 'wenanList',
            component: () => import('@/views/func/wenanList'),
            meta: {title: '文案列表', icon: 'product-list'},
        },
        {
            path: 'functionUseCountHistory',
            name: 'functionUseCountHistory',
            component: () => import('@/views/func/functionUseCountHistory'),
            meta: {title: '通用功能记录', icon: 'product-list'}
        },
        {
            path: 'audioSeparationHistory',
            name: 'audioSeparationHistory',
            component: () => import('@/views/func/audioSeparationHistory'),
            meta: {title: '音源分离记录', icon: 'product-list'}
        },
       {
            path: 'asrRealtime',
            name: 'asrRealtime',
            component: () => import('@/views/func/asrRealtime'),
            meta: {title: '录音转文字记录', icon: 'product-list'}
       }
      ]
  },

  {
      path: '/ai',
      component: Layout,
      redirect: '/ai/aiHistoryList',
      name: 'ai',
      meta: {title: 'AI功能管理', icon: 'product-list'},
      children: [
          {
            path: 'aiHistoryList',
            name: 'aiHistoryList',
            component: () => import('@/views/ai/aiHistoryList'),
            meta:{title: 'AI历史记录', icon:'product-list'},
          },
          {
              path: 'aiImageHistoryList',
              name: 'aiImageHistoryList',
              component: () => import('@/views/ai/aiImageHistoryList'),
              meta: {title: 'AI作图记录', icon: 'product-list'},
          },
          {
              path: 'aiInstructList',
              name: 'aiInstructList',
              component: () => import('@/views/ai/aiInstructList'),
              meta: {title: 'AI指令大全', icon: 'product-list'},
          }

      ]
   },
  {
    path: '/ticiqi',
    component: Layout,
    redirect: '/ticiqi/orderaward/',
    name: 'ticiqi',
    meta: {title: '提词器', icon:'product-list'},
    children: [
        {
            path: 'orderaward',
            name: 'orderaward',
            component: () => import('@/views/ticiqi/orderaward'),
            meta: {title: '订单奖品地址', icon: 'product-list'}
        },
        {
            path: 'ticiqihistory',
            name: 'ticiqihistory',
            component: () => import('@/views/ticiqi/ticiqihistory'),
            meta: {title: '功能使用记录', icon: 'product-list'}
        }
    ]
  },

  {
      path: '/fenxiao',
      component: Layout,
      redirect: '/fenxiao/awardIndex',
      name: 'fenxiao',
      meta: {title: '奖励提现管理', icon: 'product-list'},
      children: [
         {
              path: 'rewardConfig',
              name: 'rewardConfig',
              component: () => import('@/views/fenxiao/rewardConfig'),
              meta: {title: '奖励配置设置', icon: 'sms-subject'}
          },
         {
              path: 'rewardSpecs',
              name: 'rewardSpecs',
              component: () => import('@/views/fenxiao/rewardSpecs'),
              meta: {title: '奖励规格设置', icon: 'sms-subject'}
          },
         {
              path: 'awardIndex',
              name: 'awardIndex',
              component: () => import('@/views/fenxiao/awardIndex'),
              meta: {title: '奖励流水记录', icon: 'product-list'},
         },
        {
            path: 'withdrawIndex',
            name: 'withdrawIndex',
            component: () => import('@/views/fenxiao/withdrawIndex'),
            meta: {title: '用户提现管理', icon: 'product-list'},
        },
        {
            path: 'refundIndex',
            name: 'refundIndex',
            component: () => import('@/views/fenxiao/refundIndex'),
            meta: {title: '订单退款管理', icon: 'product-list'},
         },
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
 ]

export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js